export default "__VITE_ASSET__CWKsTWyY__"